import { Main } from './content.styles';

export const ModalContent = ({ children, ...otherProps }: React.HTMLProps<HTMLDivElement>) => (
  <>
    <Main {...otherProps}>{children}</Main>
  </>
);
